import React from 'react';
import './busyIndicator.scss';

export function BusyIndicator() {
   return (
      <React.Fragment>
         <div id="floatBarsG">
            <div id="floatBarsG_1" className="floatBarsG"></div>
            <div id="floatBarsG_2" className="floatBarsG"></div>
            <div id="floatBarsG_3" className="floatBarsG"></div>
            <div id="floatBarsG_4" className="floatBarsG"></div>
            <div id="floatBarsG_5" className="floatBarsG"></div>
            <div id="floatBarsG_6" className="floatBarsG"></div>
            <div id="floatBarsG_7" className="floatBarsG"></div>
            <div id="floatBarsG_8" className="floatBarsG"></div>
         </div>
      </React.Fragment>
   );
}
